module.exports = __webpack_public_path__ + "static/media/Slice 1.86fb4394.svg";